module.exports = __webpack_public_path__ + "static/media/icon-character__lech-walesa-hover.a789fe9e.svg";